<template>
    <div style="display: flex; gap: 16px; flex-direction: column">
        <div>
            <h3>{{ $t('userSettings.chooseStyle') }}</h3>

            <el-radio-group class="sp-radio-group-list" v-model="this.selectedStyle">
                <el-radio :label="1">{{ t('userSettings.style1') }}</el-radio>
                <el-radio :label="2">{{ t('userSettings.style2') }}</el-radio>
                <el-radio :label="3">{{ t('userSettings.style3') }}</el-radio>
                <el-radio :label="4">{{ t('userSettings.style4') }}</el-radio>
                <el-radio :label="0">{{ t('userSettings.styleDefault') }}</el-radio>
            </el-radio-group>

        </div>
    </div>
</template>

<script>

import { t } from '@/setup/i18n-setup'
import { Themes } from '@/scripts/themes'

export default {
    name: "ThemeSettings",
    inject: ['settings'],
    mixins: [Themes],
    data: function () {
        return {
            selectedStyle: 0,
        }
    },
    computed: {
        isDemo() {
            return this.settings.ENVIRONMENT == "DEMO";
        },
    },
    methods: {
        t,
      
    },
    watch: {
        selectedStyle(newValue, oldValue) {
            this.loadStyleSheet(newValue);
        },
    },
}
</script>